import { VIcon } from 'vuetify/lib'
import styles from './index.module.less'
import page_mixins from './page_mixins'
import w from '@/views/wage_title_mapping/constants/wage_list.js'
import {postSalaryMappingDelApi} from './service'
const w_hash = w.reduce((t, i) => {
    t[i.key] = i.label
    return t
}, {})
export default {
    mixins:[page_mixins],
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        
    },
   
    computed: {
         salary_title_mappings() {
            return this.value.salary_title_mappings || []
        }
    },
    methods: {
        showT(id) {
           
            if (!this.title_mappings_hash || !id || !this.title_mappings_hash[id]) {
             return '-'     
            }
        
            const s = this.title_mappings_hash[id]
            return `[${this.showAccountLeafTitle(s.account_title_id)}]-[${this.showAnalysisTitle(s.analysis_title_id)}]`
        }
    },
    render() {
        return <div class={[styles['d-c'], styles['d-b']]}>
            <div class={styles['d-1']}>
                <div>
                    <VIcon class={styles['bt']} on={{
                        click: () => {
                            this.$emit('edit', this.value)
                        }
                    }}>mdi-circle-edit-outline</VIcon>
                </div>
                <div class={styles['d-1-1']}>
                    <div>
                        <p class={styles['t-r']}>用工类型：</p>
                        <p class={styles['t-l']}>{this.value.employment_type}</p>
                    </div>
                    <div>
                        <p class={styles['t-r']}>人员属性：</p>
                        <p class={styles['t-l']}>{this.value.employment_form}</p>
                    </div>
                    <div>
                        <p class={styles['t-r']}>员工职能：</p>
                        <p class={styles['t-l']}>{this.showCustomerFunctionName(this.value.customer_function_id)}</p>
                    </div>
                    <div>
                        <p class={styles['t-r']}>研发项目：</p>
                        <p class={styles['t-l']}>{this.value.research ? '是' : '否'}</p>
                    </div>
                </div>
               
            </div>
            <div style="flex:1">
                <div>
                    {this.salary_title_mappings.map(item => <div class={styles['d-ti']}>
                        <p class={styles['title']}>{w_hash[item.expense_type]}：</p>
                        <p class={styles['value']}>
                            {this.showT(item.title_mapping_id)}
                            <VIcon class={styles['bt']} on={{
                                click: () => {
                                    this.$emit('itemEdit', {
                                        title_mapping_id: item.title_mapping_id,
                                        expense_type: item.expense_type,
                                        id: this.value.id,
                                        customer_function_id: this.value.customer_function_id
                                    })
                                }
                            }}>mdi-content-save-edit-outline</VIcon>
                            <VIcon class={[styles['bt'], styles['bt-e']]} on={{
                            click: () => {
                                this.$vModal.confirm({
                                    title: '提示',
                                    content: `是否删除该条目？`,
                                    onOk:({
                                        destroy,
                                        // stopLoading
                                      }) => {
                                        postSalaryMappingDelApi({id:this.value.id, expense_type: item.expense_type}).then(() => {
                                            this.$Message.success('删除成功！')
                                            const arr = []
                                            this.salary_title_mappings.forEach(i => {
                                                if (i !== item) {
                                                    arr.push(i)
                                                }
                                            });
                                            this.value.salary_title_mappings = arr
                                        }).finally(() => {
                                            destroy()
                                        })
                                      }  
                                  })
                            }
                            }}>mdi-delete-circle-outline</VIcon>
                        </p>
                    </div>)}
                    <div class={styles['d-ti']}>
                       
                         <p class={styles['title']}> <VIcon 
                            class={styles['bt']}
                            on={{
                                click:() => {
                                    this.$emit('itemEdit', {
                                        title_mapping_id: null,
                                        expense_type:null,
                                        id: this.value.id,
                                        customer_function_id: this.value.customer_function_id
                                    })
                                }
                            }}
                        >mdi-plus-circle-outline</VIcon></p>
                        <p class={styles['value']}></p>
                    </div>
               
                </div>
            </div>
        </div>
    }
}